import register from 'ShopUiBundle/modules/app/registry';

import 'SprykerCatalogBundle/components/molecules/catalog-category-model-info';
import 'SprykerProductBundle/components/atoms/product-tile-price';
import 'SprykerProductBundle/components/atoms/product-tile-rating';
import './style.scss';

// tslint:disable-next-line
register('catalog-category-model', () => import(/* webpackMode: "lazy" */'./catalog-category-model'));
